import { graphql, useStaticQuery } from 'gatsby';

const useSiteSettings = () => {
   const data = useStaticQuery(graphql`
      query SiteSettingsQuery {
         contentfulSiteSettings {
            siteTitle
            gtmContainerId
         }
      }
   `);

   return {
      siteTitle: data.contentfulSiteSettings?.siteTitle ?? '',
      gtmContainerId: data.contentfulSiteSettings?.gtmContainerId ?? '',
   };
};

export default useSiteSettings;
